import React, {useEffect, useState} from 'react';
import {InputSelect} from '@/src/app/data/types/InputTypes';
import RegisterForm from '../../../components/form/RegisterForm';
import {getLegalForms} from '../../service/registration.service';
import {useNotification} from '../../service/notification.service';
import {NotificationLevel} from '../../data/general/notificationLevel.enum';
import {LegalForm} from '../../data/types/registration/legal-form';

export default function Registration() {

	const [legalForms, setLegalForms] = useState<InputSelect[]>([]);
	const {notify} = useNotification();

	const handleGetLegalForms = (): void => {
		getLegalForms().then((res): void => {
			if (!res) {
				notify(NotificationLevel.ERROR, 'error.internalServerError');
				return;
			}

			const transformed = res
				.map((item: LegalForm) => ({
					label: item.nazev,
					value: item.kod
				}))
				.sort((a, b) => Number(a.value) - Number(b.value));

			setLegalForms(transformed);
		});
	};

	useEffect((): void => {
		handleGetLegalForms();
	}, []);

	return (
		<div className="bg-blue-light">
			<RegisterForm legalFormsData={legalForms}/>
		</div>
	);
}
